import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import StyleInspiration from './components/StyleInspiration';
import FaqSection from './components/FaqSection';
import BrandFeatures from './components/BrandFeatures';
import NewsletterSection from './components/NewsletterSection';
import { siteInfo, faqs } from '@/mocks/laceData';

export default function Home() {
  useEffect(() => {
    document.title = '蕾丝——精致优雅的时尚之选 | 蕾丝雅集 Lace Elegance';
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: window.location.origin + __BASE_PATH__,
        description: siteInfo.description,
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: siteInfo.phone,
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      },
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: window.location.origin + __BASE_PATH__,
        description: siteInfo.description,
      },
      {
        '@type': 'WebPage',
        name: '首页 - 蕾丝雅集',
        description: siteInfo.description,
        url: window.location.origin + __BASE_PATH__ + '/',
        isPartOf: { '@id': window.location.origin + __BASE_PATH__ + '/#website' },
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqs.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <HeroSection />
      <CategoryGrid />
      <FeaturedArticles />
      <StyleInspiration />
      <FaqSection />
      <BrandFeatures />
      <NewsletterSection />
    </>
  );
}